'use client';

import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { SubscriptionResponse } from '@/lib/subscription/types';
import { fetchApi } from '@/lib/api/fetch-api';
import { SUBSCRIPTION_KEY, AI_MODELS_KEY } from './query-keys';

async function fetchSubscription(): Promise<SubscriptionResponse> {
  const { data } = await fetchApi<{ data: SubscriptionResponse }>('/api/subscription');
  return data;
}

export function useSubscription(options?: { enabled?: boolean }) {
  return useQuery<SubscriptionResponse>({
    queryKey: SUBSCRIPTION_KEY,
    queryFn: fetchSubscription,
    staleTime: 30_000,
    enabled: options?.enabled,
  });
}

export function useInvalidateSubscription() {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey: SUBSCRIPTION_KEY });
    queryClient.invalidateQueries({ queryKey: AI_MODELS_KEY });
  }, [queryClient]);
}
